import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DisclaimerTypes } from '../../../interfaces/disclaimertypes';

@Component({
    selector: 'app-useraccount',
    standalone: false,

    templateUrl: './useraccount.component.html',
    styleUrl: './useraccount.component.scss'
})
export class UseraccountComponent implements OnInit {
    activeStep: number = 1;
    data = inject(MAT_DIALOG_DATA)
    dia = inject(MatDialogRef<UseraccountComponent>)
    disclaimerTypes: DisclaimerTypes = DisclaimerTypes.PAGE_FOOTER;

    ngOnInit(): void {
        if (this.data && this.data.activeStep) {
            this.activeStep = this.data.activeStep;
        }
    }

    close() {
        // Close dialog
        this.dia.close();
    }


}
